export function AlertButton(
  type = '',
  callBack = '',
  title = '',
  className = ''
) {
  this.type = type;
  this.callBack = callBack;
  this.title = title;
  this.className = className;
}
